module.exports = __webpack_public_path__ + "static/media/work_with_households_icon.95fcaa96.svg";